import * as React from 'react';

export interface IProductListRowShimmerProps {
    className?: string;
}

function randomWidth(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const ProductListRowShimmer: React.FC<IProductListRowShimmerProps> = (props) => {
    const {
        className
    } = props;

    const categoryWidth = React.useMemo(() => randomWidth(33, 171), []);
    const producerWidth = React.useMemo(() => randomWidth(50, 145), []);
    const nameWidth = React.useMemo(() => randomWidth(130, 405), []);

    const priceWidth = React.useMemo(() => randomWidth(87, 118), []);
    const volumeClWidth = React.useMemo(() => randomWidth(28, 52), []);
    const priceTotalWidth = React.useMemo(() => randomWidth(61, 90), []);

    return (
        <li>
            <div className={`${className}__product-image`}>
                <div className={`${className}__product-image__shimmer`} />
            </div>

            <div className={`${className}__product-wrapper`}>
                <div className={`${className}__product`}>
                    <div className={`${className}__product__shimmer-line`} style={{ width: categoryWidth, height: 12 }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: producerWidth, height: 12 }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: nameWidth, height: 22 }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: 54, height: 12 }} />
                </div>
                <div className={`${className}__product__price add-margin`}>
                    <div className={`${className}__product__shimmer-line`} style={{ width: priceWidth, height: 22, marginTop: 'auto', marginBottom: 6 }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: volumeClWidth, height: 10, marginTop: 'auto', marginBottom: 0 }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: 37, height: 12, marginTop: 12, marginBottom: 6 }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: priceTotalWidth, height: 16, marginTop: 'auto', marginBottom: 4 }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: 100, height: 28, marginTop: 'auto' }} />
                </div>
            </div>

            <div className={`${className}__right`}>
                <div className={`${className}__product__shimmer-line`} style={{ width: 184, height: 24 }} />
            </div>
        </li>
    );
};

export default ProductListRowShimmer;
